import { v4 as uuid } from 'uuid';
import { getTermsAndConditions } from './constants';

export const GeneralTerms = ({ handleScroll, containerRef }) => {
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString('en-us', { month: 'long' });
  const year = currentDate.getFullYear();
  const termsAndConditions = getTermsAndConditions(day, month, year);
  return (
    <div
      className="terms-and-conditions-container"
      onScroll={handleScroll}
      ref={containerRef}
    >
      <div className="section-title">
        {termsAndConditions.SAAS_SERVICE_AGREEMENT.TITLE}
      </div>
      <div className="section-content">
        {termsAndConditions.SAAS_SERVICE_AGREEMENT.PARAGRAPH_1}
      </div>
      <div className="section-content">
        {termsAndConditions.SAAS_SERVICE_AGREEMENT.PARAGRAPH_2}
      </div>
      {Object.keys(termsAndConditions.TERMS_AND_CONDITIONS.CONTENT).map(
        (element) => (
          <>
            <div className="section-subtitle" key={uuid()}>
              {
                termsAndConditions.TERMS_AND_CONDITIONS.CONTENT[element]
                  .SUBTITLE
              }
            </div>
            {termsAndConditions.TERMS_AND_CONDITIONS.CONTENT[
              element
            ].PARAGRAPHS.map((paragraph) => (
              <div className="section-content" key={uuid()}>
                {paragraph}
              </div>
            ))}
          </>
        ),
      )}
      <div className="exhibit-container">
        <div className="exhibit-title">
          {termsAndConditions.EXHIBIT_A.TITLE}
        </div>
        <div className="exhibit-subtitle">
          {termsAndConditions.EXHIBIT_A.SUBTITLE}
        </div>
        {termsAndConditions.EXHIBIT_A.CONTENT.map((el) => (
          <div className="exhibit-content" key={uuid()}>
            {el}
          </div>
        ))}
        {termsAndConditions.EXHIBIT_A.SERVICES_PROVIDED.map((el, index) => (
          <div className="exhibit-content" key={uuid()}>{`${
            index + 1
          }. ${el}`}</div>
        ))}
      </div>
      <div className="exhibit-container">
        <div className="exhibit-title">
          {termsAndConditions.EXHIBIT_B.TITLE}
        </div>
        <div className="exhibit-subtitle">
          {termsAndConditions.EXHIBIT_B.SUBTITLE}
        </div>
        {termsAndConditions.EXHIBIT_B.CONTENT.map((el) => (
          <div className="exhibit-content" key={uuid()}>
            {el}
          </div>
        ))}
      </div>
    </div>
  );
};
